import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import VentaEquipos from "@/pages/services/venta-equipos/page";
import InstalacionAires from "@/pages/services/instalacion-aires/page";
import MantenimientoCuartosFrios from "@/pages/services/mantenimiento-cuartos-frios/page";
import VentilacionMecanica from "@/pages/services/ventilacion-mecanica/page";
import CuartosFrios from "@/pages/services/cuartos-frios/page";
import DisenoRevitBim from "@/pages/services/diseno-revit-bim/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/servicios/venta-de-equipos",
    element: <VentaEquipos />,
  },
  {
    path: "/servicios/instalacion-aires",
    element: <InstalacionAires />,
  },
  {
    path: "/servicios/mantenimiento-cuartos-frios",
    element: <MantenimientoCuartosFrios />,
  },
  {
    path: "/servicios/ventilacion-mecanica",
    element: <VentilacionMecanica />,
  },
  {
    path: "/servicios/cuartos-frios",
    element: <CuartosFrios />,
  },
  {
    path: "/servicios/diseno-revit-bim",
    element: <DisenoRevitBim />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;